const binding = { modules: {}, dataActions: {} };

    (binding.modules['custom-content-block'] = {
        c: () => require('partner/modules/custom-content-block/custom-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-content-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|custom-content-block|custom-content-block'] = {
                c: () => require('partner/modules/custom-content-block/custom-content-block.view.tsx'),
                cn: '__local__-__local__-custom-content-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };